import { combineReducers } from 'redux';
import user from './user';
import house from './house';
import auction from './auction';
import invoice from './invoice';
import bulkBidding from './bulkBidding/bulkBidding';
import broadcast from './broadcast/reducer';
import reports from './reports/reducer';
import policy from './policy';
import shippingReview from './shippingReview/reducer';

export default combineReducers({
  user,
  house,
  auction,
  bulkBidding,
  invoice,
  broadcast,
  reports,
  policy,
  shippingReview
});
